// extracted by mini-css-extract-plugin
module.exports = {"rechargeCardInner":"RechargeAccountItem_rechargeCardInner__1PCW3","saveText":"RechargeAccountItem_saveText__2ul8x","blueBorder":"RechargeAccountItem_blueBorder__1yI2w"};